export enum EmailQueues {
	ABANDONED_CART_CHECK = "abandoned-cart-check",
	ABANDONED_CART_EMAIL_JOURNEY = "abandoned-cart-email-journey",
	ANNUAL_MEMBER_RETENTION_EMAIL_JOURNEY = "annual-member-retention-email-journey",
	FAILED_PAYMENT_EMAIL_JOURNEY = "failed-payment-email-journey",
	MEMBER_RETENTION_EMAIL_JOURNEY = "member-retention-email-journey",
	NEW_MEMBER_EMAIL_JOURNEY = "new-member-email-journey",
	NEW_TRIAL_EMAIL_JOURNEY = "new-trial-email-journey",
	NEW_WEBINAR_EMAIL_CAMPAIGN = "new-webinar-email-campaign",
	TRANSACTIONAL = "email.transactional",
	UPCOMING_PAYMENT_CARD_EXPIRY_EMAIL_JOURNEY = "upcoming-payment-card-expiry-email-journey",
}

export enum TransactionalEmailJobType {
	FIRST_INVITATION = "first-invitation",
	SECOND_INVITATION = "second-invitation",
	THIRD_INVITATION = "third-invitation",
}

export enum UserQueues {
	BACKUP_PAYMENT_REMINDER = "backup-payment-reminder",
}

export enum ExamQueues {
	SITE_ACCESS = "site-access",
}

export enum AiAudioQueues {
	ARTICLE_AI_AUDIO = "article-ai-audio",
	COURSE_AI_AUDIO = "course-ai-audio",
}

export enum ReportQueues {
	PACE_REPORT = "pace-report",
	RETENTION_REPORT = "retention-report",
}

export enum CertificateQueues {
	TRANSCRIPT = "transcript",
	COURSE = "course",
	CERTIFICATION = "certification",
	WORKSHOP = "workshop",
}

export enum Queues {
	CERTIFICATION_CHECK = "certification-check",
	DOCUMENT = "document",
	GEN_AI = "gen-ai",
	KNOWLEDGE = "knowledge",
	KNOWLEDGE_LAYERS = "knowledge-layers",
}

export enum KnowledgeQueueJobType {
	SYNC_NODE = "sync-node",
	DELETE_NODE = "delete-node",
	BACKFILL = "backfill",
}

export enum KnowledgeLayerQueueJobType {
	BUILD_LAYER = "build-layer",
	PASS = "pass",
}

export enum DocumentQueueJobType {
	GENERATE_COURSE_CERTIFICATE = "generate-course-certificate",
	GENERATE_CERTIFICATION_CERTIFICATE = "generate-certification-certificate",
	GENERATE_WORKSHOP_CERTIFICATE = "generate-workshop-certificate",
	GENERATE_TRANSCRIPT = "generate-transcript",
	GENERATE_ARTICLE_PDF = "generate-article-pdf",
	GENERATE_PROGRAM_PDF = "generate-program-pdf",
}

export enum GenAiQueueJobType {
	GENERATE_EXAM_ATTEMPT_SUMMARY = "generate-exam-attempt-summary",
	GENERATE_NCCA_EXAM_COACH_SUMMARY = "generate-ncca-exam-coach-summary",
	BUILD_PROGRAM = "build-program",
	REBUILD_PROGRAM = "rebuild-program",
	GENERATE_EXAM_METADATA = "generate-exam-metadata",
	GENERATE_EXAM = "generate-exam",
	REGENERATE_EXERCISE = "regenerate-exercise",
	REGENERATE_EXAM_QUESTION = "regenerate-exam-question",
	EXTRACT_PROGRAM_FROM_COURSE = "extract-program-from-course",
}
